import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/axios';

export const useUsage = () => {
  const { user } = useAuth();
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsage = useCallback(async () => {
    if (!user) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const response = await api.get('/usage/me');
      setUsage(response.data.data);
    } catch (err) {
      console.error('Error fetching usage:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [user]);

  const checkUsage = useCallback(async (feature) => {
    if (!user) return { allowed: false, remaining: 0 };
    
    try {
      const response = await api.post('/usage/check', { feature });
      return response.data.data;
    } catch (err) {
      console.error('Error checking usage:', err);
      return { allowed: false, remaining: 0 };
    }
  }, [user]);

  const incrementUsage = useCallback(async (feature) => {
    if (!user) return false;
    
    try {
      await api.post('/usage/increment', { feature });
      // Refresh usage data after increment
      await fetchUsage();
      return true;
    } catch (err) {
      console.error('Error incrementing usage:', err);
      return false;
    }
  }, [user, fetchUsage]);

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  return {
    usage,
    loading,
    error,
    fetchUsage,
    checkUsage,
    incrementUsage
  };
}; 